import i18n from '@/plugins/i18n';

const databaseESGraphs = () => ({
  lineCharts: [
    {
      width: '48%',
      title: i18n.global.t('dbm.number-of-nodes'),
      header: {
        title: i18n.global.t('dbm.number-of-nodes'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff3d3d'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_cluster_nodes',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-nodes'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-nodes'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.number-of-initializing-shards'),
      header: {
        title: i18n.global.t('dbm.number-of-initializing-shards'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#5ec5c7'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_shards_initializing',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-shards'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-shards'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.number-of-unassigned-shards'),
      header: {
        title: i18n.global.t('dbm.number-of-unassigned-shards'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ee2be1'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_shards_unassigned',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-shards'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-shards'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.total-number-of-queries'),
      header: {
        title: i18n.global.t('dbm.total-number-of-queries'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff5bb6'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_primaries_queries_total',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-queries'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-queries'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.total-time-spent-on-queries-ms'),
      header: {
        title: i18n.global.t('dbm.total-time-spent-on-queries-ms'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ffa100'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_primaries_queries_in_milliseconds',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: 'ms',
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: 'ms',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.number-of-queries-currently-in-progress'),
      header: {
        title: i18n.global.t('dbm.number-of-queries-currently-in-progress'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff8022'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_primaries_query_active',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-queries'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-queries'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.total-number-of-fetches'),
      header: {
        title: i18n.global.t('dbm.total-number-of-fetches'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#98ed78'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_primaries_query_fetches_total',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-fetches'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-fetches'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.total-time-spent-on-fetches-ms'),
      header: {
        title: i18n.global.t('dbm.total-time-spent-on-fetches-ms'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#cc9858'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_primaries_query_fetches_in_milliseconds',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: 'ms',
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: 'ms',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.number-of-fetches-currently-in-progress'),
      header: {
        title: i18n.global.t('dbm.number-of-fetches-currently-in-progress'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff5bb6'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_primaries_query_fetches',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-fetches'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-fetches'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.total-number-of-documents-indexed'),
      header: {
        title: i18n.global.t('dbm.total-number-of-documents-indexed'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#0090ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_primaries_index_docs_total',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-documents'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-documents'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.total-time-spent-indexing-documents-ms'),
      header: {
        title: i18n.global.t('dbm.total-time-spent-indexing-documents-ms'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#5ec5c7'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_primaries_index_docs_currently_indexing_in_milliseconds',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: 'ms',
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: 'ms',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.number-of-documents-currently-being-indexed'),
      header: {
        title: i18n.global.t('dbm.number-of-documents-currently-being-indexed'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#01ce01'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_primaries_index_docs_currently_indexing',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-documents'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-documents'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.total-number-of-index-refreshes'),
      header: {
        title: i18n.global.t('dbm.total-number-of-index-refreshes'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f5fe00'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_primaries_index_refreshes_total',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-index-refreshes'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-index-refreshes'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.total-time-spent-refreshing-indices-ms'),
      header: {
        title: i18n.global.t('dbm.total-time-spent-refreshing-indices-ms'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#be8ffe'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_primaries_index_refreshes_total_in_milliseconds',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: 'ms',
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: 'ms',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.total-number-of-index-flushes-to-disk'),
      header: {
        title: i18n.global.t('dbm.total-number-of-index-flushes-to-disk'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#0090ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_primaries_flushes_total',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-index-flushes'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-index-flushes'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t(
        'dbm.total-time-spent-on-flushing-indices-to-disk-ms',
      ),
      header: {
        title: i18n.global.t(
          'dbm.total-time-spent-on-flushing-indices-to-disk-ms',
        ),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff8022'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_primaries_flush_total_time_in_milliseconds',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: 'ms',
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: 'ms',
      },
    },
    {
      width: '48%',
      title: i18n.global.t(
        'dbm.total-number-of-get-requests-where-the-document-was-missing',
      ),
      header: {
        title: i18n.global.t(
          'dbm.total-number-of-get-requests-where-the-document-was-missing',
        ),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#98ed78'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_primaries_get_documents_missing',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: 'ms',
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: 'ms',
      },
    },
    {
      width: '48%',
      title: i18n.global.t(
        'dbm.total-time-spent-on-get-requests-where-the-document-was-missing-ms',
      ),
      header: {
        title: i18n.global.t(
          'dbm.total-time-spent-on-get-requests-where-the-document-was-missing-ms',
        ),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff3d3d'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_primaries_get_documents_missing_in_milliseconds',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: 'ms',
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: 'ms',
      },
    },
  ],
});
export default databaseESGraphs;
